import { Box, ButtonGroup as ButtonGroupBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const ButtonGroup = styled(ButtonGroupBase)`
  height: ${(p) => p.theme.spacing(3)};
  &:hover {
    background-color: transparent !important;
  }
`;
